import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface SavedOrderStateType {
    readonly isModalOpen: boolean;
    readonly savedCartName: string;
}

export type CustomSavedOrderState = Readonly<SavedOrderStateType>;

export const initialSavedOrderState: CustomSavedOrderState = {
    isModalOpen: false,
    savedCartName: "",
};

export const customSavedCartModalReducer = createTypedReducer(initialSavedOrderState, {
    "Custom/SavedOrderState/SetOpenModal": (
        draft: Draft<CustomSavedOrderState>,
        { isModalOpen }: { isModalOpen: boolean },
    ) => ({
        ...draft,
        isModalOpen,
    }),
    "Custom/SavedOrderState/UpdateSavedOrderName": (
        draft: Draft<CustomSavedOrderState>,
        { savedCartName }: { savedCartName: string },
    ) => ({
        ...draft,
        savedCartName,
    }),

    "Custom/SavedOrderState/Reset": (draft: Draft<CustomSavedOrderState>) => ({
        ...draft,
        isModalOpen: false,
        savedCartName: "",
    }),
});
